import { InputGroup } from "@components/_Revamp/InputGroup";
import { useAvivaDispatch, useAvivaSelector } from "@redux/hook";
import { updateSrsForm } from "@redux/slices/EVER_GREEN/step4Slice";
import { EverGreenStyle } from "@utils/Style/everGreen";
import React, { useCallback, useEffect, useRef, useState } from "react";
import LearnPolicy from "./learn-policy";
import { styled } from "@linaria/react";
import { Tooltip } from "@pages/EverGreen/Components/Tooltip";
import tooltipWhite from "@assets/icon/info-black.svg";
import { trackOnLoad } from "@pages/EverGreen/Helpers/analyticsHelper";

const bankDropDownList = [
  { label: "DBS", id: "1" },
  { label: "OCBC", id: "2" },
  { label: "UOB", id: "3" },
]

function SrsForm({ show }: {show:string}) {
  const srsform = useAvivaSelector((state) => state.everGreenStep4.srsForm);
  const dispatch = useAvivaDispatch();
  const prevAccountNum = useRef(srsform.accountNum);
  const [isError, setError] = useState(false)
  const handleOnChange = useCallback((e) => {
    if (e.target.name === "operator") {
      dispatch(
        updateSrsForm({
          operator: {
            label: bankDropDownList.reduce((acc,current)=>{ return e.target.value.toString() === current.id ? current.label : acc },""),
            id: e.target.value.toString(),
          },
        })
      );
    } else {
        let regex;
        switch(srsform.operator.id){
            case "1": {
                regex =  new RegExp(`^$|^[0-9]{0,14}$`)
                break;
            }
            case "2":{
                regex =  new RegExp(`^$|^[0-9]{0,12}$`)
                break;
            }
            case "3": {
                regex =  new RegExp(`^$|^[0-9]{0,9}$`)
                break;
            }

        }
        let flag = regex?.test(e.target.value)
      if ( flag || (e.target.value.length < prevAccountNum.current.length)) {
        dispatch(
          updateSrsForm({
            accountNum: e.target.value,
          })
        );
        prevAccountNum.current = e.target.value
      }else 
      prevAccountNum.current = e.target.value

    }
  }, [srsform.operator.id]);

  const validateSrs = useCallback(function(accNo: string, bankId: string){
    if(!bankId) return false
   switch(bankId){
    // DBS
    case "1":{
      if(accNo.length === 14 && accNo.endsWith("223")){
        return true;
      }
      return false
    }
    // OCBC
    case "2":{
      if(accNo.length === 12){
        return true;
      }
      return false
    }
    case "3":{
      if(accNo.length === 9){
        return true;
      }
      return false
    }
   }
  },[])

  useEffect(()=>{
   setError(srsform.accountNum===""?false: !validateSrs(srsform.accountNum, srsform.operator.id))
  },[srsform])

  // useEffect(()=>{
  //   if(show === "srs"){
  //     trackOnLoad()
  //   }
  // },[])
  return (
    <>
      <h4>How to pay via SRS</h4>
      <ol>
        <li>
          Log in to your bank&apos;s internet banking portal or mobile banking app.
        </li>
        <li>Find the option for Fund Transfer or Payments.</li>
        <li>Select SRS Account to retrieve your SRS details.</li>
        <li>
          Enter your SRS Operator and Account details on this page to pay.
        </li>
      </ol>
      <div className="srs-form">
        <InputGroup
          label="SRS Operator"
          id="operator"
          name="operator"
          inputType="dropdown"
          placeholder="Select"
          theme={EverGreenStyle}
          dropdownProps={{
            value: srsform.operator.id,
            source: bankDropDownList,
          }}
          onChange={handleOnChange}
        />
        <SrsAcContainer>
          <InputGroup
            id="srs-nric"
            name="account"
            label="SRS Account No."
            inputProps={{
              textAlign: "left",
              value: srsform.accountNum,
            }}
            inputType="input"
            invalid={isError}
            errorMessage="Enter a valid SRS account number without alphabets or special characters."
            theme={EverGreenStyle}
            onChange={handleOnChange}
          />
          <span>
            <Tooltip
              title="SRS Account Number"
              inlineComponent={
                <>
                  <img
                    src={tooltipWhite}
                    width={"13.3px"}
                    height={"13.3px"}
                    alt="tooltip"
                  />
                </>
              }
            >
              <p>
                {/* <div> Validation for SRS bank account number:</div>
                <ul style={{ marginTop: "0px" }}>
                  <li>DBS - 14 Digits (Last 3 Digits is 223)</li>
                  <li>OCBC - 12 Digits</li>
                  <li>UOB - 9 Digits (Last 2 Digits is 18)</li>
                </ul>
                <div> No Alphabet/Special characters allowed</div> */}
                To find your SRS account number, check with the respective bank that you opened the SRS account with: DBS, UOB or OCBC.
              </p>
            </Tooltip>
          </span>
        </SrsAcContainer>
      </div>
    </>
  );
}

export default SrsForm;

const SrsAcContainer = styled.div`
  position: relative;
 &> span {
    position:absolute;
    top:5px;
    left: 115px;
  }
`